(function () {
  // run only when swatches exist inside collection product grid
  document.addEventListener(
    "click",
    function (e) {
      const label = e.target.closest("label.color-swatch[data-variant-swatch]");
      if (!label) return;

      const grid = label.closest('#product-grid[data-id]');
      if (!grid) return; // COLLECTION PAGE ONLY

      e.preventDefault();
      e.stopPropagation();

      const card = label.closest("[data-product-card]");
      if (!card) return;

      const variantId = label.getAttribute("data-variant-id");
      const imageUrl =
  label.getAttribute("data-variant-main-image") ||
  label.getAttribute("data-image-url");


      // 1) make radio checked (keeps your dark border behavior)
      const inputId = label.getAttribute("for");
      if (inputId) {
        const input = document.getElementById(inputId);
        if (input) input.checked = true;
      }

      // 2) swap main image
      if (imageUrl) {
  const mainImg = card.querySelector("img[data-card-main-image]");
  if (mainImg && mainImg.src !== imageUrl) {
    mainImg.removeAttribute("srcset");
    mainImg.removeAttribute("sizes");
    mainImg.src = imageUrl;
  }
}



      // 3) update all product links (title + stretched link) to selected variant
      if (variantId) {
        const baseUrl = card.getAttribute("data-product-url") || "";
        const variantUrl = baseUrl ? `${baseUrl}?variant=${variantId}` : `?variant=${variantId}`;

        card.querySelectorAll("a[data-card-link]").forEach((a) => {
          a.href = variantUrl;
        });

        // 4) update your CTA "Choose options" link + .cta-row for your ATC script
        const ctaLink = card.querySelector(".cta-row a.btn-atc");
        if (ctaLink) ctaLink.href = variantUrl;

        const ctaRow = card.querySelector(".cta-row");
        if (ctaRow) ctaRow.dataset.variantId = variantId;

        // 5) update quick-add hidden input if present
        const idInput = card.querySelector('input[name="id"]');
        if (idInput) idInput.value = variantId;
      }
    },
    true
  );
})();
